import { SankeyPreview } from '@/components/TokenProfile/SankeyPreview';
import { TransactionModule } from '@/components/TransactionModule';
import type { TransactionModuleProps } from '@/components/TransactionModule/types';
import { TradeEngineProvider } from '@/components/TransactionModule/useTradeEngine';

import { Panel } from '@/ui/Panel';

import type { TokenResult } from '@/utils/0x/token-registry.types';

type TradeModuleCardProps = Omit<TransactionModuleProps, 'variant' | 'className'> & {
  buyToken?: TokenResult;
  showSankeyPreview: boolean;
};

export const TradeModuleCard = ({
  buyToken,
  showSankeyPreview,
  ...props
}: TradeModuleCardProps) => (
  <TradeEngineProvider
    sellTokenAddress={props.sellTokenAddress}
    sellTokenChainId={props.sellTokenChainId}
    buyTokenAddress={props.buyTokenAddress}
    buyTokenChainId={props.buyTokenChainId}
  >
    <Panel className="w-full">
      <TransactionModule {...props} variant="widget" />
    </Panel>
    {showSankeyPreview && (
      <SankeyPreview buyToken={buyToken} chainId={props.buyTokenChainId ?? 1} />
    )}
  </TradeEngineProvider>
);
